import React, { FC } from "react";

interface SectionCardProps {
  title: string;
  subTitle?: string;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
  children: React.ReactNode;
  headerClassName?: string;
}

const SectionCard: FC<SectionCardProps> = ({
  title,
  subTitle,
  icon,
  actions,
  children,
  headerClassName = "",
}) => {
  return (
    <div className="bg-white rounded-3xl border border-gray-100 shadow-sm ">
      <div
        className={`flex items-center justify-between px-5 py-4 border-b border-gray-100 bg-gradient-to-l from-[#fff7fa] to-[#fffdfd] ${headerClassName}`}
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-2xl bg-[#fce8f0] text-[#7a1b2b] flex items-center justify-center">
            {icon}
          </div>
          <div>
            <div className="text-sm md:text-base font-extrabold text-gray-800">
              {title}
            </div>
            {subTitle ? (
              <div className="text-[11px] md:text-xs text-gray-400 mt-0.5">
                {subTitle}
              </div>
            ) : null}
          </div>
        </div>
        {actions}
      </div>

      <div className="p-5">{children}</div>
    </div>
  );
};

export default SectionCard;
